import {CustomIcons} from './components/CustomIcons';
import GlobalStyles from './components/GlobalStyles';
import {initializeApp} from './init';
import router from './router';
import './util/shims';
import {Loader, ThemeProvider, ToastContainer} from '@sproutsocial/racine';
import {
	ExternalSprite as ExternalIconsHtml,
	GeneralSprite as GeneralIconsHtml,
	SproutSprite as SproutIconsHtml,
} from '@sproutsocial/seeds-icons';
import {Sprite as IllustrationsHtml} from '@sproutsocial/seeds-illustrations';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {RouterProvider} from 'react-router';

await initializeApp();

const root = createRoot(document.getElementById('root')!);

root.render(
	<React.StrictMode>
		<ThemeProvider>
			<QueryClientProvider client={new QueryClient()}>
				<GlobalStyles />

				<div style={{display: 'none'}}>
					<div dangerouslySetInnerHTML={{__html: ExternalIconsHtml}} />
					<div dangerouslySetInnerHTML={{__html: GeneralIconsHtml}} />
					<div dangerouslySetInnerHTML={{__html: SproutIconsHtml}} />
					<div dangerouslySetInnerHTML={{__html: IllustrationsHtml}} />
					<CustomIcons />
				</div>

				<RouterProvider router={router} fallbackElement={<Loader delay />} />

				<ToastContainer />
			</QueryClientProvider>
		</ThemeProvider>
	</React.StrictMode>,
);
